export const mappingTopNavigationDesktop = (item) => {

	const brands = {
		id: 200,
		name: "Brands",
		slug: "brands",
		items: [],
	};

	const categoryNavigationDesktop = item?.data?.[0]?.children_data?.filter((val) => val.include_in_menu === "1").map((value) => ({
		id: value.entity_id,
		name: value.category_name,
		slug: value.category_path,
		is_virtual: value.is_virtual || null,
		items: value.children_data.length > 0
			? value.children_data.map((child) => ({
				id: child.entity_id,
				name: child.category_name,
				slug: child.category_path,
				is_virtual: child.is_virtual || null,
				items: child.children_data.length > 0
					? child.children_data.map((childs) => ({
						id: childs.entity_id,
						name: childs.category_name,
						slug: childs.category_path,
						items: childs.children_data.length > 0
							? childs.children_data.map((lastChilds) => ({
								id: lastChilds.entity_id,
								name: lastChilds.category_name,
								slug: lastChilds.category_path,
							})) : [],
					})) : [],
			})) : [],
	}));

	categoryNavigationDesktop?.splice(1, 0, brands);
	return categoryNavigationDesktop;

};

export const mappingToPopupCategoryMobile = (item) => {

	const categoryNavigationDesktop = item?.data?.[0]?.children_data?.map((value) => ({
		id: value.entity_id,
		name: value.category_name,
		slug: value.category_path,
		is_virtual: value.is_virtual || null,
		items: value.children_data.length > 0
			? value.children_data.map((child) => ({
				id: child.entity_id,
				name: child.category_name,
				slug: child.category_path,
				is_virtual: child.is_virtual || null,
				items: child.children_data.length > 0
					? child.children_data.map((childs) => ({
						id: childs.entity_id,
						name: childs.category_name,
						slug: childs.category_path,
						items: childs.children_data.length > 0
							? childs.children_data.map((lastChilds) => ({
								id: lastChilds.entity_id,
								name: lastChilds.category_name,
								slug: lastChilds.category_path,
							})) : [],
					})) : [],
			})) : [],
	}));

	return categoryNavigationDesktop;

};

export const mappingParentAndSubparentCategory = (getStoreCategoryMobile) => {

	const storeCategory = [];
	const parentCategory = [];
	const subParentCategory = [];
	getStoreCategoryMobile?.data?.[0]?.children_data?.forEach((item) => {

		storeCategory.push({
			id: item.entity_id,
			name: item.category_name,
			slug: item.category_slug,
			children_data: item.children_data,
		});

	});

	storeCategory.forEach((subcat) => {

		parentCategory[subcat.slug] = subcat.id;
		subcat.children_data.forEach((subchild) => {

			subParentCategory[subchild.category_slug] = subchild.entity_id;

		});

	});

	return {
		parentCategory,
		subParentCategory,
	};

};
